export default __webpack_public_path__ + "static/media/ic_round-drag-handle.70635699.svg";